import {
  Card,
  Top,
  Actions,
  Link,
  Button,
  Title,
  GoToPreview,
  Background,
  Image,
  Statistics,
  StatItem,
  StatNumber,
  StatLabel,
  ActionButtons,
  GoToLeadsList,
  ShareButton,
  Circle,
  Separator
} from "./styles";
import postEditIcon from "../../../../../assets/icons/post-edit-icon.svg";
import targetIcon from "../../../../../assets/icons/target.svg";
import shareIcon from "../../../../../assets/icons/share-medium.svg";

import { connect, useDispatch } from "react-redux";
import { Post } from "../../../../../types/post";
import { useEffect, useState } from "react";
import Icon from "../../../../../components/Icon";

import background1 from "../../../../../assets/backgrounds/membership/background-1.svg";
import background2 from "../../../../../assets/backgrounds/membership/background-4.svg";
import background3 from "../../../../../assets/backgrounds/membership/background-5.svg";
import deleteIcon from '../../../../../assets/icons/delete.svg'
import { showModal } from "../../../../../store/actions/modal";

const backgrounds = [background1, background2, background3];
const randomBg = Math.floor(Math.random() * backgrounds.length);

interface ComponentProps {
  post: Post;
  isMine?: boolean;
  groupInformation;
  userInformation;
  setLeadMagnetToDelete?;
  style?;
  showActions?: boolean;
  coverPicHeight?: number;
  blockedPost?: boolean;
  onShare?: () => void;
}

const Component = ({
  setLeadMagnetToDelete,
  post,
  isMine = false,
  groupInformation,
  userInformation,
  style,
  showActions = true,
  coverPicHeight = 123,
  blockedPost = false,
  onShare
}: ComponentProps) => {
  const dispatch = useDispatch();
  const [ownGroup, setOwnGroup] = useState(false);
  const [image, setImage] = useState<string>();

  useEffect(() => {
    if (!!groupInformation && !!userInformation) {
      setOwnGroup(groupInformation?.expert?.id === userInformation?.expert?.id);
    }
  }, [groupInformation, userInformation]);

  //TODO: debemos optimizar esto para encapsular esta logica de manejo de quailities y formatos en CDN en el front
  function getOptimizedImage(fullUrl, quality = 75) {
    if (!fullUrl?.startsWith(`https://${process.env.MEDIA_CDN_DOMAIN}`)) return fullUrl;

    const transformation = `/cdn-cgi/image/quality=${quality},format=auto`;
    return fullUrl.replace(`https://${process.env.MEDIA_CDN_DOMAIN}`, `https://${process.env.MEDIA_CDN_DOMAIN}${transformation}`);
  }

  useEffect(() => {
    if (!!post) {
      const coverPicUrl = post.cover_pic?.signed_url || post.cover_pic?.url;
      console.log(post.cover_pic?.signed_url, post.cover_pic?.url)
      const hasCoverPic = !!coverPicUrl;
      const finalImage = hasCoverPic ? getOptimizedImage(coverPicUrl) : backgrounds[randomBg];

      setImage(finalImage);
    }
  }, [post]);

  return (
    <Card style={{ ...style }}>
      <Top>
        {showActions && (
          <Actions className="article-actions">
            {(ownGroup || isMine) && (
              <>
                {/* <Circle>
                  <CopyToClipboad
                    copy={`${process.env.REACT_APP_SITE_BASE_URL}/group/${groupInformation?.id}/p/${post.id}`}
                  >
                    <Icon icon={postCopyLinkIcon} size="14px" color={"black"} />
                  </CopyToClipboad>
                </Circle> */}

                <Circle>
                  <Link
                    href={`/dashboard/community/${groupInformation?.id}/lead-magnets/${post.id}`}
                    options={{
                      native: true,
                      size: "sm",
                      type: "filled",
                      skin: "white",
                    }}
                  >
                    <Icon icon={postEditIcon} size="18px" color={"black"} />
                  </Link>
                </Circle>

                {!!post.total_leads && Number(post?.total_leads) <= 0 && (
                  <Circle>
                    <Button
                      onClick={() => {
                        setLeadMagnetToDelete?.(post);
                        dispatch(showModal("modal-delete-lead-magnet"));
                      }}
                      options={{
                        size: "sm",
                        type: "filled",
                        skin: "white",
                      }}
                    >
                      <Icon icon={deleteIcon} size="18px" color={"black"} />
                    </Button>
                  </Circle>
                )}
              </>
            )}
          </Actions>
        )}
      </Top>

      <GoToPreview
        coverPicHeight={coverPicHeight}
        to={{ pathname: `/group/${groupInformation?.id}/p/${post.id}` }}
        target="_blank"
      >
        <Background className="background" height={coverPicHeight} >
          <Image backgroundImage={image} block={blockedPost} />
        </Background>
        <Title>{post.title}</Title>
        <div style={{ height: 18 }} />
        <Statistics>
          <StatItem>
            <StatNumber>{post.total_leads}</StatNumber>
            <StatLabel>Leads</StatLabel>
          </StatItem>
          <Separator />
          <StatItem>
            <StatNumber>{post.active_customers}</StatNumber>
            <StatLabel>Clientes activos</StatLabel>
          </StatItem>
        </Statistics>
      </GoToPreview>

      <ActionButtons>
        <GoToLeadsList
          href={`/dashboard/community/members?lead_magnet_id=${post.id}`}
          style={{ gap: 4 }}
          options={{
            type: "filled",
            size: "lg",
            skin: "purple",
          }}
        >
          <Icon icon={targetIcon} size="24px" color="white" />
          Ver listado
        </GoToLeadsList>

        <ShareButton
          onClick={() => {
            navigator.clipboard.writeText(`${process.env.REACT_APP_SITE_BASE_URL}/group/${groupInformation?.id}/p/${post.id}`);
            onShare?.();
          }}
          options={{
            type: "outline",
            size: "lg",
            skin: "black",
          }}
        >
          <Icon icon={shareIcon} size="14px" color="black" />
          Compartir
        </ShareButton>
      </ActionButtons>
    </Card >
  );
};

const state = ({ userStore }) => {
  const { data: userInformation } = userStore.information;

  return {
    userInformation,
  };
};

export default connect(state)(Component);
